export default __webpack_public_path__ + "static/media/banglore.bab63cff.webp";